@if ((done$ | async) === false) {
  <h1>{{ 'review_input.title' | translate }}</h1>
  <app-review-activity-description [activity]="(item$ | async)"></app-review-activity-description>
  <hr/>
  <h1>{{ 'review_input.rating.title' | translate }}</h1>
  <div class="flex-1 gap-4 flex-row items-center justify-center" style="width: 100%">
    <div>
      @for (input of ratingInputs; track input) {
        <div >
          <h3>{{input.name}}</h3>
          <app-review-rating height="40px" [editable]="true" [(value)]="input.value" (valueChange)="calculateTotal()">
          </app-review-rating>
        </div>
      }
    </div>
    <div class="flex-1 flex-col items-end justify-start">
      <h3>{{ 'review_input.average_rating' | translate }}</h3>
      <h1 class="xl-rating">{{ (currentRating / 20) | i18n_number: '1.1-1' | async }}</h1>
      <app-review-rating height="25px" [editable]="false" [(value)]="currentRating"></app-review-rating>
    </div>
  </div>
  <form [formGroup]="reviewForm" class="flex-col">
    <div class="flex-col gap-2">
      <span class="disclaimer">
        {{ 'review_input.character_count' | translate: {
        characterCount: reviewForm.value.reviewContent?.length ?? 0,
        maxChars } }}
      </span>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'review_input.content.label' | translate }}</mat-label>
        <textarea
          [maxlength]="maxChars"
          rows="6"
          matInput
          formControlName="reviewContent"
          [placeholder]="'review_input.content.placeholder' | translate"
        ></textarea>
      </mat-form-field>
      <span class="disclaimer">
        {{ 'review_input.character_count' | translate: {
        characterCount: reviewForm.value.reviewTips?.length ?? 0,
        maxChars } }}
      </span>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'review_input.tips.label' | translate }}</mat-label>
        <textarea
          [maxlength]="maxChars"
          rows="3"
          matInput
          formControlName="reviewTips"
          [placeholder]="'review_input.tips.placeholder' | translate"
        ></textarea>
      </mat-form-field>
      <span class="disclaimer">{{ 'review_input.tips.disclaimer' | translate }}</span>
    </div>
    <p>{{ 'review_input.job_title.title' | translate }}</p>
    <div class="function-inputs flex-1 flex-row justify-between items-center">
      <mat-form-field appearance="outline" [style.width.%]="reviewForm.value.position === EJobTitle.OTHER ? 45 : 100">
        <mat-label>{{ 'review_input.job_title.label' | translate }}</mat-label>
        <mat-select formControlName="position" (selectionChange)="functionChange()">
          @for (jobTitle of EJobTitle | keyvalue: originalOrder; track jobTitle) {
            <mat-option [value]="jobTitle.value">
              {{ ('review.job_title.' + jobTitle.value) | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (reviewForm.get('position').value === EJobTitle.OTHER) {
        <mat-form-field appearance="outline" [style.width.%]="50">
          <!-- The required asterisk is added her manually on purpose because the custom conditional required validator does not trigger it -->
          <mat-label>{{ 'review_input.job_title.description.label' | translate }}*</mat-label>
          <input [maxlength]="maxJobtitleChars" matInput formControlName="positionElaboration"/>
        </mat-form-field>
      }
    </div>
    <p>{{ 'review_input.age_group.title' | translate }}</p>
    @if ((ageGroups$ | async)?.length > 0) {
      <mat-form-field appearance="outline">
        <mat-label>{{ 'review_input.age_group.label' | translate }}</mat-label>
        <mat-select formControlName="ageGroup">
          @for (group of (ageGroups$ | async); track group) {
            <mat-option [value]="group.id">{{group.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <button color="primary" mat-flat-button (click)="submit()" [disabled]="reviewForm.invalid || reviewForm.pristine">
      {{ 'review_input.submit' | translate }}
    </button>
  </form>
} @else {
  <div class="flex-1 flex-row items-center justify-center flex-fill">
    <div class="flex-1 flex-col items-center justify-start gap-4">
      <div class="flex-1 flex-row items-center justify-end">
        <img width="128px" src="../../../../assets/images/party-popper.gif"/>
        <h1>{{ 'review_input.thanks' | translate }}</h1>
        <img class="d-sm-none d-xl-block" width="128px" src="../../../../assets/images/party-popper.gif" [style.transform]="'scaleX(-1)'"/>
      </div>
      <h3>{{ 'review_input.will_be_shown_soon' | translate }}</h3>
    </div>
  </div>
  <h1>{{ 'review_input.preview.title' | translate }}</h1>
  @if (currentReview$ | async; as review) {
    <app-review-preview [review]="review"></app-review-preview>
  }
  <button (click)="goBack()" color="primary" mat-flat-button>
    <mat-icon>chevron_left</mat-icon>
    {{ 'review_input.back' | translate }}
  </button>
}
